// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__-Wfk-","footerHover":"Footer_footerHover__Xg5rj"};